// extracted by mini-css-extract-plugin
export default {"phoneFormatter":"PhoneInput_phoneFormatter__Q55ih","disabled":"PhoneInput_disabled__GyTNH","error":"PhoneInput_error__6Pbi8"};